var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-0 p-1",attrs:{"variant":_vm.alertVariant,"show":""}},[_c('p',{staticClass:"mb-0"},[_vm._v("\n        Plan de charge : "+_vm._s(_vm.charge)+" h | Coût : "+_vm._s(_vm.cost)+"€ | Budget :\n        "+_vm._s(_vm.budget)+"€\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }